import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ShopFilters = ({
  activeCollectionFilter,
  priceRange,
  collections,
  handlePriceRangeChange,
  handleCollectionFilter,
  setActiveCollectionFilter,
  setPriceRange,
  handleApplyPriceRange,
  handleResetPriceRange,
  onSearch
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchQuery);
    }
  };

  return (
    <aside className="shop-sidebar">
      <div className="widget">
        <div className="sidebar-search">
          <form onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Rechercher..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button type="submit"><i className="fa fa-search" /></button>
          </form>
        </div>
      </div>
      <div className="widget">
        <div className="sidebar-header">
          <h4 className="sidebar-title">Collection</h4>
          {activeCollectionFilter && activeCollectionFilter.length > 0 && (
            <button
              onClick={() => setActiveCollectionFilter([])}
              className="clear-filters-btn"
            >
              Effacer
            </button>
          )}
        </div>
        <div className="shop-brand-list">
          <ul>
            {collections.map(collection => (
              <li key={collection._id}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleCollectionFilter(collection._id);
                  }}
                  className={activeCollectionFilter && activeCollectionFilter.includes(collection._id) ? 'selected' : ''}
                >
                  {collection.name}
                  {collection.status === 'archived' && <span className="badge badge-secondary ml-2">Archivé</span>}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="widget">
        <h4 className="sidebar-title">Filtrer par Prix</h4>
        <div className="price_filter">
          <div className="double-slider-container">
            <div className="slider-track"></div>
            <input
              type="range"
              min="0"
              max="150"
              value={priceRange.min}
              onChange={(e) => handlePriceRangeChange('min', e.target.value)}
              className="slider slider-min"
            />
            <input
              type="range"
              min="0"
              max="150"
              value={priceRange.max}
              onChange={(e) => handlePriceRangeChange('max', e.target.value)}
              className="slider slider-max"
            />
          </div>
          <div className="price_slider_amount">
            <div className="price-inputs">
              <div className="price-input-group">
                <input
                  type="number"
                  min="0"
                  max="150"
                  value={priceRange.min}
                  onChange={(e) => handlePriceRangeChange('min', e.target.value)}
                  className="price-input"
                  placeholder="0"
                />
                <span className="currency">TND</span>
              </div>
              <span className="price-separator">-</span>
              <div className="price-input-group">
                <input
                  type="number"
                  min="0"
                  max="150"
                  value={priceRange.max}
                  onChange={(e) => handlePriceRangeChange('max', e.target.value)}
                  className="price-input"
                  placeholder="150"
                />
                <span className="currency">TND</span>
              </div>
            </div>
            <div className="price-filter-buttons">
              <button
                type="button"
                className="btn btn-sm btn-apply"
                onClick={handleApplyPriceRange}
              >
                Appliquer
              </button>
              <button
                type="button"
                className="btn btn-sm"
                onClick={handleResetPriceRange}
              >
                Réinitialiser
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="widget shop-widget-banner">
        <Link to="/shop"><img src="img/product/just_chew_it_green.png" alt="" /></Link>
      </div>
    </aside>
  );
};

export default ShopFilters;